const knowledgebaseEn = {
    "failed_to_load": "Failed to load articles",
    "welcome_to_knowledgebase": "Welcome to the knowledgebase!",
    "choose_from_categories": "Please choose from the categories below or use the search box above to answer your questions!",
    "search_placeholder": "Search...",
    "not_found_what_you_looking_for": " Please write to the following email address: ",
    "article_button": "Continue",
    "knowledgebase": "Knowledgebase",
    "article_not_found": "Article not found",
    "back_to_list": "Back to list page",
    "no_articles_found": "No articles",
    "search_for_any_keyword": "Search for any keywords!",
}

export default knowledgebaseEn;